var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeginner1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 290,
    viewBox: "0 0 515 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 515,
    height: 290,
    fill: "#FFC900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.505 261.934C500.505 264.85 497.416 266.731 494.83 265.39C486.497 261.064 475.134 256.259 461.331 255.361C441.084 254.04 434.265 261.185 412.917 261.963C388.71 262.845 377.485 245.356 346.016 244.796C314.66 244.24 302.883 260.202 277.793 258.442C255.129 256.851 251.851 248.184 232.9 249.638C215.733 250.959 208.681 260.964 192.409 262.402C177.445 263.723 168.439 252.735 146.194 253.597C126.703 254.354 128.597 263.549 106.581 264.162C90.7354 264.601 79.0589 255.063 57.7237 255.8C44.9597 256.239 26.4722 269.446 19.8707 267.243C17.5064 266.454 15.0293 265.406 15.0293 262.913V25.1655C20.6722 25.1332 28.6754 25.1655 39.2362 26.4866C51.9076 28.0695 61.683 33.9702 78.4104 34.8482C107.012 36.3546 115.381 23.8444 143.113 22.9663C166.881 22.0842 172.173 33.6077 202.973 33.0881C232.34 32.5927 239.505 22.1124 259.753 22.5232C281.322 22.9623 290.123 38.3967 320.492 38.8075C353.061 39.2466 366.711 24.5331 379.032 24.2834C400.6 23.8444 404.999 37.4864 438.01 37.4864C473.221 37.4864 474.981 23.4013 487.745 23.4013C493.263 23.4013 497.722 24.5089 500.509 25.1614C500.505 104.086 500.505 183.01 500.505 261.934Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.262 32.8337V253.463C481.293 249.178 471.631 246.765 461.936 246.129C460.083 246.008 458.25 245.947 456.486 245.947C447.025 245.947 440.174 247.671 433.556 249.335C427.301 250.91 421.396 252.4 412.583 252.714C412.108 252.73 411.629 252.742 411.158 252.742C402.325 252.742 395.554 249.738 386.987 245.927C376.378 241.215 364.355 235.87 346.181 235.544C345.593 235.536 345.001 235.532 344.421 235.532C330.368 235.532 319.928 238.532 310.878 241.742C310.846 241.755 310.814 241.763 310.781 241.779C307.716 213.967 298.344 203.982 290.618 200.744C278.668 195.338 245.427 195.741 234.475 199.411C225.747 202.339 222.895 207.869 222.098 209.987C212.947 204.32 202.337 202.677 194.685 205.637C186.118 208.948 180.684 220.822 180.684 228.761C180.68 237.006 180.644 246.701 182.783 252.086C180.853 251.522 178.835 250.793 176.608 249.987C169.592 247.454 160.859 244.3 148.671 244.3C147.737 244.3 146.782 244.316 145.832 244.356C134.353 244.8 128.363 247.949 123.546 250.475C119.095 252.811 115.583 254.656 106.323 254.917C106.049 254.925 105.776 254.925 105.514 254.925C100.004 254.925 94.7354 253.355 88.6333 251.538C80.7348 249.182 71.777 246.511 60.0602 246.511C59.1862 246.511 58.292 246.523 57.4059 246.556C49.2376 246.838 40.4651 250.676 32.7237 254.063C30.1902 255.171 26.7666 256.669 24.2734 257.535V34.5294C28.2126 34.6784 32.8204 34.9966 38.0927 35.6572C42.6844 36.2291 46.9257 37.4939 51.8436 38.9519C59.0251 41.0866 67.1652 43.5073 77.9275 44.0752C79.6715 44.1679 81.4034 44.2162 83.087 44.2162C97.2286 44.2162 106.73 41.0182 115.921 37.9248C124.118 35.1698 131.859 32.5639 143.407 32.1973H143.455C144.201 32.1651 144.942 32.153 145.667 32.153C154.004 32.153 159.409 33.9575 166.249 36.2412C174.82 39.0969 184.527 42.3433 200.976 42.3433C201.685 42.3433 202.398 42.3352 203.127 42.3272C220.176 42.0412 230.741 38.5371 239.232 35.7257C245.934 33.5064 251.231 31.7502 258.593 31.7502C258.912 31.7502 259.238 31.7543 259.56 31.7623C267.451 31.9194 273.271 34.6059 280.641 38.0094C290.095 42.3715 301.86 47.7969 320.363 48.0507C320.883 48.0547 321.403 48.0587 321.914 48.0587C343.503 48.0587 357.403 41.9526 367.553 37.4979C372.342 35.3954 376.478 33.5748 379.217 33.5225C379.495 33.5144 379.773 33.5144 380.039 33.5144C387.325 33.5144 391.953 35.5041 398.357 38.2591C407.122 42.0291 418.033 46.7255 438.007 46.7255C462.592 46.7255 473.363 40.12 480.488 35.7498C484.318 33.4057 485.724 32.6444 487.742 32.6444C488.978 32.6444 490.154 32.7169 491.262 32.8337Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.209 242.537C247.968 241.228 243.195 240.229 237.017 240.229C235.466 240.229 233.847 240.289 232.191 240.418C221.707 241.224 214.405 244.724 207.96 247.813C202.559 250.403 197.895 252.638 191.591 253.19C191.032 253.239 190.464 253.267 189.912 253.267C187.535 253.267 185.232 252.812 182.783 252.091C180.644 246.71 180.68 237.011 180.684 228.766C180.684 220.827 186.122 208.949 194.685 205.642C203.244 202.327 215.508 204.776 225.292 212.179C235.075 219.578 246.055 229.362 252.209 242.537Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.672 186.594V197.32C267.084 196.579 258.476 196.494 250.916 196.945V186.554C254.763 187.44 258.774 187.911 262.887 187.911C266.939 187.911 270.882 187.456 274.672 186.594Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M310.783 241.783C309.019 242.407 307.303 243.047 305.624 243.668C297.419 246.705 290.334 249.331 281.63 249.331C280.583 249.331 279.512 249.29 278.444 249.218C269.051 248.557 263.509 246.539 258.148 244.582C256.223 243.881 254.278 243.172 252.211 242.536C246.053 229.361 235.077 219.578 225.294 212.179C224.254 211.389 223.187 210.66 222.1 209.991C222.897 207.873 225.749 202.343 234.477 199.414C238.074 198.214 244.063 197.36 250.922 196.945C258.478 196.49 267.09 196.579 274.678 197.32C281.175 197.952 286.923 199.072 290.624 200.748C298.345 203.986 307.718 213.971 310.783 241.783Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2517 246.714C58.6109 242.15 59.7789 228.996 57.2898 221.025C55.0906 213.984 49.8062 208.261 32.2007 212.22C31.7617 193.732 31.7617 66.9742 31.7617 66.9742C31.7617 66.9742 49.8062 66.9742 51.5663 52.8891C63.8913 55.5313 95.1388 62.1328 110.984 61.2507C126.829 60.3686 140.548 46.3882 174.804 54.2102C215.295 63.4539 231.141 45.4054 254.031 47.1696C276.92 48.9338 309.831 60.0545 331.493 57.7345C356.139 55.0923 378.106 38.2279 407.195 50.2509C440.207 63.897 466.613 50.6899 466.613 50.6899C466.613 50.6899 471.454 63.4539 485.1 64.336C485.1 72.2586 484.218 224.106 484.218 224.106C484.218 224.106 475.397 221.065 468.812 224.988C464.22 227.719 459.967 236.306 465.114 246.408",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M485.104 232.775C481.435 230.048 475.591 227.515 472.425 229.903C469.259 232.288 476.997 236.34 480.948 237.451C486.127 238.905 486.494 243.388 481.725 242.953C475.832 242.418 471.156 237.012 471.156 237.012",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M477.902 226.854V248.793",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M483.322 35.6474V57.2927",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M488.325 38.1081C488.325 38.1081 477.547 39.8964 476.781 43.1066C475.823 47.1464 479.697 46.647 484.656 45.3138C489.614 43.9806 490.685 48.1937 487.946 50.0625C483.487 53.1035 477.112 52.5638 477.112 52.5638",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 39.7413V61.302",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8567 44.3529C42.8773 41.7107 35.8569 40.8045 33.8873 42.6572C31.9177 44.51 34.2578 48.3082 41.1413 49.5165C48.786 50.8578 47.481 57.1129 38.7367 56.1785C33.5731 55.6267 29.9844 53.5 29.9844 53.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2285 216.29V242.169",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 218.086C41.9623 216.801 32.2996 222.202 31.7559 226.641C31.2121 231.08 37.4391 230.995 43.2995 228.192C49.7198 225.122 54.8189 228.586 50.1991 234.233C44.8099 240.823 37.1491 240.436 37.1491 240.436",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.776 62.8994L160.933 66.323L165.851 67.9462L161.328 71.1926L163.261 76.7228L157.337 73.0816L152.684 76.7228L154.396 71.0597L150.973 67.9462L156.676 67.8576L157.776 62.8994Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.679 85.9537L142.716 91.2261L147.819 91.9148L142.889 94.1503L143.751 99.5958L138.648 95.411L132.401 99.1366L135.841 93.5219L131.543 90.0822L137.387 91.0569L139.679 85.9537Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.224 181.324L140.911 186.995L147.682 187.607L143.899 190.109L147.255 195.353L140.85 192.851L133.774 198.402L135.421 192.304L129.625 190.717L134.994 188.336L138.224 181.324Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.371 207.375L153.942 213.252L149.08 216.382H153.978L152.733 221.618L157.708 217.022L164.341 220.788L160.684 215.777L164.643 211.822L159.178 213.175L155.371 207.375Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M436.376 71.3168L434.076 78.4702L427.789 79.2395L432.747 81.5917L430.907 87.2145L436.835 82.357L443.481 85.5792L441.234 81.5393L446.857 78.1157L438.781 77.6042L436.376 71.3168Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M452.358 103.934L456.023 108.429H461.739L457.82 111.772L462.899 117.105L456.088 114.857L452.809 120.061L451.846 114.406L445.611 114.857L450.815 110.552L452.358 103.934Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M459.363 141.333C459.363 141.333 455.573 145.638 455.186 148.466C453.708 148.917 449.273 151.938 449.273 151.938L456.793 154.056L456.088 160.291L461.486 154.701L467.974 159.264L464.378 151.68L470.097 148.53L461.679 148.143L459.363 141.333Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M454.598 178.143L452.056 182.75L443.775 183.975L449.273 187.833L446.599 191.974L453.374 188.587L458.831 193.384L456.854 186.988L463.536 185.199L455.347 184.067L454.598 178.143Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M432.515 209.405L428.551 216.869L420.955 217.73L425.643 221.098L423.331 226.253L430.203 221.166L434.891 226.253L434.102 220.042L439.189 217.465L432.45 216.011L432.515 209.405Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M381.747 162.46C392.055 162.46 400.411 154.103 400.411 143.795C400.411 133.487 392.055 125.13 381.747 125.13C371.439 125.13 363.082 133.487 363.082 143.795C363.082 154.103 371.439 162.46 381.747 162.46Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M372.982 135.908H391.486L389.887 138.671C389.661 139.061 389.541 139.5 389.537 139.951L389.424 151.402C389.424 151.402 382.766 152.462 382.766 156.647C382.766 152.583 376.048 150.045 376.048 150.045V140.503C376.048 139.891 375.83 139.299 375.439 138.828L372.982 135.908Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M378.428 135.908V151.213",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M382.23 135.908L382.762 156.651",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M385.641 135.908L386.217 152.401",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.681 165.773C132.966 165.773 142.114 156.624 142.114 145.34C142.114 134.055 132.966 124.907 121.681 124.907C110.396 124.907 101.248 134.055 101.248 145.34C101.248 156.624 110.396 165.773 121.681 165.773Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.195 147.048C108.195 142.839 111.989 138.107 115.083 138.107C117.346 138.107 119.948 139.23 119.884 138.211C119.743 135.984 118.031 135.299 116.65 134.872C117.101 132.858 120.818 132.085 124.165 133.479C125.418 134.002 125.209 138.316 125.209 138.316C125.209 138.316 130.078 137.027 132.201 138.421C133.945 139.565 134.847 141.212 135.012 142.908C135.113 143.911 134.855 144.398 133.679 144.523C131.512 144.748 128.479 145.002 128.479 145.002V146.742L131.818 147.664V155.579L128.185 156.042C127.649 156.111 127.13 156.272 126.647 156.522C125.611 157.057 123.815 158.145 122.566 159.788C121.648 158.237 119.928 157.102 118.881 156.513C118.361 156.223 117.789 156.038 117.197 155.966L111.567 155.265V148.273L115.151 147.088C115.151 147.088 115.151 145.586 115.151 144.652C115.151 143.717 112.888 143.608 111.917 144.237C110.942 144.857 108.195 147.048 108.195 147.048Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M110.613 143.148C111.282 142.037 113.67 139.592 113.67 139.592H121.476C121.476 139.592 121.476 137.538 121.476 137.231C121.476 136.925 121.045 135.258 119.422 135.258C119.422 134.674 119.422 134.315 119.422 134.315H123.422C124.449 134.315 125.121 137.65 123.422 137.65C123.422 137.985 123.422 139.511 123.422 139.511C123.422 139.511 129.645 139.511 130.559 139.511C131.477 139.511 133.447 143.148 133.447 143.148C133.447 143.148 129.584 143.148 128.613 143.148C127.643 143.148 127.087 145.956 127.087 145.956H116.893C116.893 145.956 117.183 143.342 115.922 143.096C113.642 142.649 110.613 143.148 110.613 143.148Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M115.725 149.298V154.172C114.593 153.971 113.485 153.846 112.547 153.814V149.298H115.725V149.298Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M120.051 149.299V155.297H119.874C118.975 154.938 117.936 154.64 116.877 154.402V149.295H120.051V149.299Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M127.2 149.298V154.744C126.616 154.913 126.056 155.094 125.545 155.3H124.582V149.302H127.2V149.298Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.301 149.298V154.071C129.64 154.176 128.96 154.309 128.291 154.466V149.298H130.301V149.298Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.788 149.298V156.186C123.224 156.569 122.849 156.987 122.745 157.43C122.716 157.515 122.708 157.604 122.708 157.688C122.708 157.6 122.7 157.511 122.676 157.43C122.531 156.83 121.899 156.283 120.984 155.799V149.298H123.788Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6855 233.452C82.7078 229.992 86.5462 226.806 96.0035 223.455C105.461 220.104 110.052 216.322 110.431 214.433C110.81 212.544 89.9537 223.455 77.7415 233.887",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4258 230.149C86.9409 228.768 99.7855 226.553 102.331 226.11C91.9233 229.247 88.0486 231.906 88.5279 233.307C89.0072 234.709 108.828 225.965 108.828 225.965",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101.813 228.957C100.419 231.277 101.656 231.833 111.306 228.582C113.836 227.732 117.211 227.217 114.81 232.715",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M111.186 241.125C115.056 234.923 127.712 221.224 139.871 220.302C144.233 219.931 135.203 231.004 128.078 233.883C120.953 236.763 116.164 236.208 111.186 241.125Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.969 237.017C117.969 237.017 135.389 221.837 136.311 220.914",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130.991 232.34C132.582 233.017 130.765 236.062 126.508 237.016C131.116 235.599 139.425 232.586 142.917 230.705C146.759 230.85 157.792 230.383 157.792 230.383",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M187.09 211.543C182.22 226.579 184.113 242.432 191.597 253.19Z",
    fill: "#FF7051"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M187.09 211.543C182.22 226.579 184.113 242.432 191.597 253.19",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M200.684 235.436C200.684 233.084 202.601 233.365 201.425 230.115C200.249 226.869 195.282 227.517 192.797 229.93C190.695 231.972 189.519 239.077 194.622 240.474C200.035 241.961 200.684 235.436 200.684 235.436Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M207.9 220.332C210.063 219.377 210.438 220.924 213.04 218.729C215.641 216.533 213.402 213.082 210.365 212.204C207.791 211.458 200.868 213.468 201.262 217.851C201.681 222.495 207.9 220.332 207.9 220.332Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M232.819 232.165C234.551 230.169 234.009 226.862 231.608 224.779C229.207 222.696 225.856 222.625 224.124 224.621C222.392 226.617 222.935 229.924 225.336 232.007C227.736 234.091 231.087 234.161 232.819 232.165Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M280.542 215.566C282.995 210.958 285.605 202.564 285.605 193.321C285.605 188.137 280.489 190.433 280.276 198.025C280.88 191.363 278.02 188.35 274.645 190.441C270.843 192.797 273.517 211.292 273.517 211.292L273.135 212.827L274.79 215.856L280.542 215.566Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M243.175 197.651C235.474 190.332 227.358 195.258 232.216 201.578C236.872 207.833 267.475 220.472 267.475 220.472C266.311 225.559 271.986 227.565 271.986 227.565C271.986 227.565 266.722 233.164 266.323 236.233C265.924 239.302 269.481 240.192 271.575 237.433C273.67 234.674 277.984 225.462 277.984 225.462C280.61 231.428 278.1 236.841 281.411 237.477C285.326 238.235 286.377 234.94 286.128 230.135C285.87 225.156 282.567 224.528 282.567 224.528C286.482 223.948 286.406 221.028 284.436 219.211C282.015 216.98 278.116 213.27 278.116 213.27C278.116 213.27 276.058 212.481 270.862 210.088C265.663 207.696 252.121 199.528 251.009 196.946C250.599 195.81 250.711 192.692 247.413 191.609C244.352 190.602 240.594 192.709 243.175 197.651Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M278.114 213.267C278.114 213.267 270.747 213.065 267.477 220.468",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M271.982 227.561C271.982 227.561 276.107 224.556 277.372 224.178C278.64 223.799 282.559 224.528 282.559 224.528",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M262.396 218.298L263.174 246.339",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M257.112 227.222C258.231 227.222 259.138 226.315 259.138 225.196C259.138 224.077 258.231 223.17 257.112 223.17C255.993 223.17 255.086 224.077 255.086 225.196C255.086 226.315 255.993 227.222 257.112 227.222Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M257.008 235.226C258.184 235.226 259.138 234.272 259.138 233.095C259.138 231.919 258.184 230.965 257.008 230.965C255.831 230.965 254.877 231.919 254.877 233.095C254.877 234.272 255.831 235.226 257.008 235.226Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M296.486 246.867L304.832 196.669L311.82 197.551L303.217 244.555L296.486 246.867Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M303.053 207.362L309.642 209.46L310.25 206.125L303.588 204.144L303.053 207.362Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M309.423 197.244L308.364 201.059L308.227 197.103C308.215 196.765 308.481 196.483 308.815 196.471C309.153 196.459 309.435 196.725 309.447 197.059C309.447 197.123 309.435 197.188 309.423 197.244Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M306.834 196.898L305.888 200.885L305.63 196.793C305.61 196.455 305.864 196.165 306.202 196.144C306.54 196.124 306.83 196.378 306.85 196.716C306.85 196.781 306.846 196.841 306.834 196.898Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M314.274 176.401C309.71 178.918 310.975 183.103 306.649 186.289C302.323 189.475 301.034 194.518 304.829 196.673C308.623 198.828 313.267 198.264 316.03 194.228C317.79 191.662 317.48 187.646 315.841 185.339C314.322 183.2 312.945 179.301 314.274 176.401Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M54.494 91.3855C54.494 91.3855 54.494 84.6832 54.494 83.6964C54.494 82.5485 59.7824 81.5375 60.5558 82.8667C61.6715 84.7799 58.5781 86.1856 54.1113 86.8663",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7112 85.6784C62.304 86.2947 61.4944 89.6417 59.6416 90.1009C57.6278 90.5963 54.4941 90.1573 54.4941 90.1573",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.082 84.8692C65.3859 81.2683 67.8026 81.8443 67.6858 83.5561C67.569 85.2679 64.1736 89.8636 64.1736 89.8636H70.0219",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4727 90.6572C85.4727 90.6572 86.4635 87.4793 86.6407 83.9107C87.3617 83.52 90.6886 82.7708 90.6886 82.7708V90.6532",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3008 86.9843H90.687",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M96.984 86.3555C96.984 86.3555 99.0502 86.7542 98.0836 88.462C97.1169 90.1658 93.5523 90.1416 93.5523 90.1416V83.7213C95.099 82.4687 98.4863 82.0861 98.587 83.3749C98.72 85.0263 98.2125 86.9879 93.1777 86.9879",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M112.675 86.3555C112.675 86.3555 114.742 86.7542 113.775 88.462C112.808 90.1658 109.244 90.1416 109.244 90.1416V83.7213C110.79 82.4687 114.178 82.0861 114.278 83.3749C114.411 85.0263 113.904 86.9879 108.869 86.9879",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M107.225 82.7708H103.197L101.779 90.1376H106.584",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M102.529 86.2463H106.029",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M117.066 84.1118C118.186 81.6186 121.251 82.7181 120.317 84.9334C119.378 87.1527 117.868 90.1373 117.868 90.1373H121.618",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M315.921 134.878C315.921 160.12 298.287 181.238 274.672 186.595C270.882 187.457 266.939 187.912 262.891 187.912C258.775 187.912 254.767 187.441 250.921 186.555C227.394 181.129 209.861 160.048 209.861 134.878C209.861 126.907 211.621 119.343 214.775 112.56L308.542 107.872C313.226 115.779 315.921 125.014 315.921 134.878Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M214.769 112.56C217.85 106.788 216.746 104.283 212.598 104.23C207.068 104.162 190.965 109.551 183.916 101.951C176.867 94.3502 181.979 85.1105 191.448 81.1472C206.488 74.8598 221.717 74.2355 232.362 73.0594C243.004 71.8833 257.769 69.9419 257.769 69.9419C257.769 69.9419 251.933 65.467 252.493 62.5872C253.053 59.7073 259.767 59.3891 262.724 69.3015C262.724 69.3015 281.03 67.8636 295.336 67.5413C309.647 67.2231 324.949 68.8181 328.235 73.7401C330.966 77.8363 327.639 89.2792 321.831 92.1833C316.023 95.0873 308.129 102.2 308.531 107.863",
    fill: "#FF7051"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M214.769 112.56C217.85 106.788 216.746 104.283 212.598 104.23C207.068 104.162 190.965 109.551 183.916 101.951C176.867 94.3502 181.979 85.1105 191.448 81.1472C206.488 74.8598 221.717 74.2355 232.362 73.0594C243.004 71.8833 257.769 69.9419 257.769 69.9419C257.769 69.9419 251.933 65.467 252.493 62.5872C253.053 59.7073 259.767 59.3891 262.724 69.3015C262.724 69.3015 281.03 67.8636 295.336 67.5413C309.647 67.2231 324.949 68.8181 328.235 73.7401C330.966 77.8363 327.639 89.2792 321.831 92.1833C316.023 95.0873 308.129 102.2 308.531 107.863",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M250.409 147.506C252.185 147.506 253.624 146.067 253.624 144.292C253.624 142.517 252.185 141.078 250.409 141.078C248.634 141.078 247.195 142.517 247.195 144.292C247.195 146.067 248.634 147.506 250.409 147.506Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M273.159 147.506C274.935 147.506 276.374 146.067 276.374 144.292C276.374 142.517 274.935 141.078 273.159 141.078C271.384 141.078 269.945 142.517 269.945 144.292C269.945 146.067 271.384 147.506 273.159 147.506Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M256.027 153.683H269.251",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M257.068 187.69C260.162 194.762 265.877 192.225 266.675 187.911L257.068 187.69Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginner1);
export default __webpack_public_path__ + "static/media/beginner1.c93ac887844eb5e65574fb4a8ebc5703.svg";
export { ForwardRef as ReactComponent };